import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useAutomationTemplate, useTemplateEmailAutoSaves } from '../useAutomationTemplates';
import { AutomationEditorProvider } from './AutomationEditorProvider';
import { EditAutomationTemplateContent } from './EditAutomationTemplateContent';
import { useFeatureSurface } from '../FeatureSurfaceContext';
import styles from './EditAutomationTemplate.module.css';

const { pageContainer, loading, error, backButton, backButtonIcon } = styles;

export const EditAutomationTemplate: React.FC = () => {
  const featureSurface = useFeatureSurface();
  const { 'automation-id': automationId } = useParams<{
    'automation-id': string;
  }>();

  const { data: templateResponse, error: fetchError } = useAutomationTemplate(automationId);
  const { isPending: emailAutoSavesArePending } = useTemplateEmailAutoSaves(automationId);
  const editorIsReady = templateResponse?.template && !emailAutoSavesArePending;

  const loadingMessage = <div className={loading}>Loading automation template...</div>;

  const errorMessage = <div className={error}>Failed to load automation template</div>;

  const loadStatesContent = fetchError ? errorMessage : loadingMessage;

  return (
    <div className={pageContainer}>
      <Link to={featureSurface.automationsPath} className={backButton}>
        <ArrowLeft className={backButtonIcon} />
        Back to automations
      </Link>
      {editorIsReady ? (
        <AutomationEditorProvider template={templateResponse.template}>
          <EditAutomationTemplateContent />
        </AutomationEditorProvider>
      ) : (
        loadStatesContent
      )}
    </div>
  );
};
